'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = 'M576 160c0 47.4-25.8 88.7-64 110.8l0 241.2-128 0 0-118.1-80 47.1 0 23 48 0 0 48-288 0 0-328c0-22.1-17.9-40-40-40l-24 0 0-48 24 0c48.6 0 88 39.4 88 88l0 95.1c40-53.7 101.7-90.6 173-97.1l36.3-3.3c-.6-4-1-8-1.2-12.1l-.2-6.6 0-180.8C340.1-7.4 374.5 15.5 423.2 48l49.5 0C521.5 15.5 555.9-7.4 576-20.8L576 160zM289.3 229.8C192 238.6 116.8 318 112.2 414.6l-.2 9.4 0 40 144 0 0-64c0-17.7-14.3-32-32-32l-32 0 0-48 32 0c39.4 0 72.1 28.6 78.7 66.1 71.6-42.1 114.7-67.5 129.3-76.1l0 154 32 0 0-177c-5.2 .7-10.6 1-16 1-46.8 0-87.7-25.1-110.1-62.6l-48.6 4.4zM493.3 92l-6 4-78.6 0-6-4-34.7-23.1 0 91.2 .4 8.2c4.1 40.3 38.2 71.8 79.6 71.8 44.2 0 80-35.8 80-80l0-91.2-34.7 23.1zM416 164a20 20 0 1 1 0-40 20 20 0 1 1 0 40zm64 0a20 20 0 1 1 0-40 20 20 0 1 1 0 40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;